export { School as default } from './School';
